import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../context/auth-context.js';

interface ProtectedRouteProps {
  /** When set, users with a different role see an Access Denied screen. */
  requiredRole?: 'admin' | 'user';
}

export function ProtectedRoute({ requiredRole }: ProtectedRouteProps) {
  const { user, loading } = useAuthContext();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--bg-primary)]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[var(--border)] border-t-[var(--accent)]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    const correctPortalUrl =
      user.role === 'admin'
        ? 'https://enterprise-mgmt.intecular.com'
        : 'https://enterprise-portal.intecular.com';

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[var(--bg-primary)] px-4 text-center">
        <p className="text-4xl">🔒</p>
        <h1 className="text-2xl font-semibold text-[var(--text-primary)]">Access Denied</h1>
        <p className="max-w-sm text-sm text-[var(--text-secondary)]">
          Your account ({user.role}) does not have access to this portal.
        </p>
        <a
          href={correctPortalUrl}
          className="mt-2 rounded-lg bg-[var(--accent)] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
        >
          Go to your portal
        </a>
      </div>
    );
  }

  return <Outlet />;
}
